import { Box, Button, Typography } from '@mui/material';
import { chain } from 'lodash';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DialogCustom from '../../../../common/component/DialogCustom';
import { some } from '../../../../common/constants';
import ExamFormDialog from '../ExamFormDialog';
import GroupExamFormDialog from '../GroupExamFormDialog';
import ExamTableCSV from './ExamTableCSV';

interface Props {
  onSubmit?: (formVal: some[]) => void;
  open?: boolean;
  isInsurance?: boolean;
  onClose?: () => void;
  dataCSV?: some[];
}

const CSVPreviewDialog: React.FunctionComponent<Props> = (props) => {
  const { open, onClose, dataCSV, isInsurance, onSubmit } = props;
  const [data, setData] = React.useState<some[]>([]);
  const [formData, setFormData] = React.useState<some | undefined>();
  const [formDataGroup, setFormDataGroup] = React.useState<some | undefined>();

  const onDelete = React.useCallback((value: some) => {
    setData((old) => old.filter((val) => val.id !== value.id));
  }, []);

  const onDeleteGroup = React.useCallback((value: some) => {
    setData((old) => old.filter((val) => val.group !== value.name));
  }, []);
  const onSubmitForm = React.useCallback(({ listData, ...value }: some) => {
    if (value.id) {
      setData((old) =>
        old.map((val) => {
          if (val.id === value.id) {
            return value;
          }
          return val;
        }),
      );
    } else {
      setData((old) => [...old, { ...value, group: listData?.[0]?.group }]);
    }
    setFormData(undefined);
  }, []);

  const onSubmitFormGroup = React.useCallback((value: some) => {
    setData((old) =>
      old.map((val) => {
        if (val.group === value.group) {
          return { ...val, group: value.name };
        }
        return val;
      }),
    );
    setFormDataGroup(undefined);
  }, []);

  const getValidate = React.useCallback(
    (value: some) => {
      if (isInsurance) {
        if (!value.code || !value.departmentCode || !value.groupCode) {
          return false;
        }
      }
      if (!value.name || !value.price) {
        return false;
      }
      return true;
    },
    [isInsurance],
  );

  const dataMapped = React.useMemo(() => {
    return chain(data.map((val) => ({ ...val, validation: getValidate(val) })))
      .groupBy('group')
      .map((value, key) => ({
        group: key,
        name: key,
        services: value,
      }))
      .value()
      .sort((a: some, b: some) => a.group.localeCompare(b.group));
  }, [data, getValidate]);

  return (
    <>
      <DialogCustom
        open={!!open}
        maxWidth="xs"
        keepMounted={false}
        onClose={onClose}
        TransitionProps={{
          onEnter: () =>
            setData(
              dataCSV
                ? dataCSV.slice(1).map((v, index) => ({
                    id: index + 1,
                    group: v.data[0],
                    code: v.data[1],
                    name: v.data[2],
                    specializedDepartmentId: v.data[4],
                    price: v.data[5],
                  }))
                : [],
            ),
        }}
        PaperProps={{
          style: { minWidth: '70vw', overflow: 'hidden' },
        }}
        disableCloseOutSide
        title={
          <Typography variant="h6" color="primary">
            <FormattedMessage id={'CSVPreview'} />
          </Typography>
        }
      >
        <Box padding={2} overflow="auto">
          {dataMapped?.length ? (
            dataMapped?.map((value: some) => {
              return (
                <ExamTableCSV
                  key={value.id}
                  setFormData={setFormData}
                  setFormDataGroup={setFormDataGroup}
                  onDelete={onDelete}
                  onDeleteGroup={onDeleteGroup}
                  data={value}
                  enableDeleteGroup
                />
              );
            })
          ) : (
            <FormattedMessage id="noData" />
          )}
        </Box>
        <Box padding={2} display="flex" justifyContent="flex-end">
          <Button variant="outlined" color="primary" style={{ minWidth: 100, marginRight: 16 }} onClick={onClose}>
            <FormattedMessage id={'cancel'} />
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ minWidth: 100 }}
            disabled={dataMapped.length === 0 || !!data.find((val) => !getValidate(val))}
            onClick={() => {
              onSubmit && onSubmit(data);
            }}
          >
            <FormattedMessage id={'save'} />
          </Button>
        </Box>
      </DialogCustom>
      <ExamFormDialog
        open={!!formData}
        formData={formData}
        onSubmit={onSubmitForm}
        onClose={() => {
          setFormData(undefined);
        }}
        isInsurance={isInsurance}
      />
      <GroupExamFormDialog
        open={!!formDataGroup}
        formData={formDataGroup}
        onSubmit={onSubmitFormGroup}
        onClose={() => {
          setFormDataGroup(undefined);
        }}
      />
    </>
  );
};
export default CSVPreviewDialog;
